const bank = process.env.BANK

const componentConfig = {
  personalData: {
    /*
      component: PersonalData.jsx
      route: /personaldata/personaldata
    */
    privacyCard: {
      isVisible: () => {
        const supportedBanks = ['NEXIBUSINESS']
        return supportedBanks.includes(bank)
      }
    },
    helpBox: {
      isVisible: () => {
        const supportedBanks = ['NEXIBUSINESS']
        return supportedBanks.includes(bank)
      }
    }
  },
  changeEmail: {
    /*
      component: ChangeEmail.jsx
      route: /personaldata/change-email
    */
    iamDoubleVerify: {
      isActive: () => {
        const supportedBanks = ['NEXIBUSINESS']
        return supportedBanks.includes(bank)
      }
    },
    singleDoubleOtpUci: {
      isActive: () => {
        const supportedBanks = ['UCI']
        return supportedBanks.includes(bank)
      }
    }
  },
  changePhoneNumber: {
    /*
      component: ChangePhoneNumber.jsx
      route: /personaldata/change-number
    */
    iamDoubleVerify: {
      isActive: () => {
        const supportedBanks = ['NEXIBUSINESS']
        return supportedBanks.includes(bank)
      }
    },
    singleDoubleOtpUci: {
      isActive: () => {
        const supportedBanks = ['UCI']
        return supportedBanks.includes(bank)
      }
    }
  }
}

export default componentConfig
